/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signing_NewInputs */

const cs_signing_new = /** @type {(inputs: Signing_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nový podpis`)
};

const en_signing_new = /** @type {(inputs: Signing_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New signing`)
};

/**
* | output |
* | --- |
* | "New signing" |
*
* @param {Signing_NewInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const signing_new = /** @type {((inputs?: Signing_NewInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signing_NewInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signing_new(inputs)
	return cs_signing_new(inputs)
});